import React from 'react'
import { ListHeader } from './ListHeader'
import { ListRow } from './ListRow'
import { Table } from '@ztechapps/webui.data-tools'
import type { MutationConfig } from '@ztechapps/common.utils'
import type { Invoice } from '@ztechapps/totalmilk-payme.contract'
import { InvoiceStatusEnum } from '@ztechapps/totalmilk-payme.contract'

export type ItemListProps = {
  updateMutationConfig: MutationConfig
  deleteMutationConfig: MutationConfig
  canEdit: boolean
  invoice: Partial<Invoice>
}
export const ItemList = (props: ItemListProps) => {
  const data = props.invoice?.items ?? []
  const canEdit = props.canEdit && props?.invoice?.status === InvoiceStatusEnum.Draft

  const createRow = (m) => {
    return (
      <ListRow
        {...m}
        deleteMutationConfig={props.deleteMutationConfig}
        canEdit={canEdit}
        invoice={props.invoice}
        updateMutationConfig={props.updateMutationConfig}
      />
    )
  }

  return (
    <div>
      <Table head={<ListHeader />} dataArray={data} row={createRow} />
    </div>
  )
}
